<script setup lang="ts">
import { computed } from "vue";

import { boardHistoryItemClosed, boardHistoryItemOpened } from "@/analytics/events/history";
import { trackEvent } from "@/analytics/track";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import ListItem from "@/components/ui/ComplexList/ListItem.vue";
import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";

import DiffList from "./DiffList.vue";
import type { StickyChangesBySticky } from "./groupChanges";
import { cardFromStickyChange } from "./groupChanges";

const props = defineProps<{ change: StickyChangesBySticky; expanded: boolean }>();
const emit = defineEmits<{ expanded: [opened: boolean] }>();

const card = computed(() => cardFromStickyChange(props.change));

function handleExpanded(opened: boolean) {
  emit("expanded", opened);
  trackEvent(opened ? boardHistoryItemOpened("compare") : boardHistoryItemClosed("compare"));
}
</script>

<template>
  <ListItem is-collapsable class="list-item-sticky-diffs" :expanded @expanded="handleExpanded">
    <div class="change-title">
      <TypeDot size="medium" :color="card.color" />
      <BaseTooltip only-show-on-overflow class="change-description">
        <template #content>{{ card.text }}</template>
        {{ card.text }}
      </BaseTooltip>
    </div>
    <template #collapsedContent>
      <DiffList :changes="change.changes" />
    </template>
  </ListItem>
</template>

<style lang="scss">
@use "@/styles/mixins/utils";
@use "changes";
@use "activityListItem";

.list-item.list-item-sticky-diffs {
  @include activityListItem.sticky-changes-border-left;
}

.list-item-sticky-diffs {
  @include changes.sticky-change;

  .change-title {
    display: flex;
    align-items: center;
    gap: 12px;

    .change-description {
      @include utils.ellipsis;

      min-width: 0;
    }
  }
}
</style>
